<div class="app-content content content-dssawere">
    <div class="content-overlay"></div>
    <div class="content-wrapper p-0">
        <div class="content-body">
            <section class="row flexbox-container">
                <div class="col-12 d-flex align-items-center justify-content-center">
                    <div class="col-xxxxl-4 col-xxl-5 col-xl-6 col-md-8 col-10 box-shadow-2 p-0">
                        <div class="card px-1 py-1 m-0">
                            <div class="card-header d-block pb-0">
                                <div class="card-title text-center d-block">
                                    <img src="assets/images/logo/logo-dark.png" alt="branding logo">
                                </div>
                                <h6 class="card-subtitle line-on-side text-center fw-normal pt-2">
                                    <span>{{ 'register.validation.subtitle' | translate }}</span>
                                </h6>
                            </div>
                            <div class="card-content">
                                <app-alert></app-alert>
                                <div class="card-body pb-2">
                                    <form class="form-horizontal" [formGroup]="validationForm" (ngSubmit)="tryValidate()">
                                        <fieldset class="form-group input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text input-group-icon"><i class="feather ft-mail"></i></span>
                                            </div>
                                            <input type="email" formControlName="email" class="form-control" email
                                                [ngClass]="{ 'is-invalid': submitted && f.email.errors }"
                                                placeholder="{{ 'register.validation.emailPlaceholder' | translate }}" required>
                                            <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
                                                <div *ngIf="f.email.errors.required">{{ 'validations.emailRequired' | translate}}</div>
                                            </div>
                                        </fieldset>
                                        <fieldset class="form-group input-group">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text input-group-icon"><i class="la la-key"></i></span>
                                            </div>
                                            <input type="text" placeholder="{{ 'register.validation.codePlaceholder' | translate }}" 
                                            formControlName="code" class="form-control"
                                            [ngClass]="{ 'is-invalid': submitted && f.code.errors }"
                                            id="user-password" required>
                                            <div *ngIf="submitted && f.code.errors" class="invalid-feedback">
                                                <div *ngIf="f.code.errors.required">{{ 'validations.passwordRequired' | translate }}</div>
                                            </div>
                                        </fieldset>
                                        <fieldset class="form-group">
                                            <button type="submit" class="btn btn-success btn-block" [disabled]="loading">
                                                <i class="fa fa-refresh fa-spin" *ngIf="loading"></i>
                                                <i class="fa fa-check" *ngIf="!loading"></i> {{ 'register.validation.validateButton' | translate }}
                                            </button>
                                        </fieldset>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>